<template>
    <main class="mt-5" id="page-refund">
      <div class="card mt-3">
        <div class="card-header  border-0">
          <h5 class="card-title font-bold py-3">گزارش مالی مرجوعی ها</h5>
          <div style="flex: 1"></div>
          <button @click="print" class="btn btn-primary">
            <span
              style="transform: translateY(3px)"
              class="feather-printer"
            ></span>
          </button>
        </div>
        <div class="row px-4 not-in-print">
          <form
            autocomplete="chrome-off"
            @submit.prevent="doFilter"
            class="col-12 row"
          >
            <div class="col-6">
              <DatePickerRange
                :fromFormatType="'YYYY-MM-DD'"
                :toFormatType="'YYYY-MM-DD'"
                :fromType="'date'"
                :toType="'date'"
                :dfFType="'jYYYY-jMM-jDD'"
                :dfTType="'jYYYY-jMM-jDD'"
                v-model="filter.date"
              />
            </div>
            <div class="col-6 d-flex">
            <label for="" style="width: 28%;">انتخاب صندوق دار</label>
                <select v-model="adminSelected" class="form-control">
                    <option v-for="admin in cashiers" :value="admin">{{ admin.name }}</option>
                    <option :value="null">همه</option>
                </select>
            </div>
            <div class="col-6 mt-1 d-flex">
              <button :disabled="disabled" type="submit" class="btn btn-primary">
                فیلتر
              </button>
            </div>
          </form> 
        </div>
        <div id="print-box" class="p-4">
          <div class="print-only">
            <h4>فروشگاه اروین</h4>
          </div>
          <br>
          <div
              class="d-flex mb-3 mr-2-print"
          >
              <span class="ml-1 font-bold">گزارش مرجوعی ها</span>
              <div v-if="appliedFilter.date.startDate">
                  <span>از</span>
                  <span class="font-weight-bold mx-1">تاریخ</span
                      ><span> {{ appliedFilter.date.startDate | persianDate }}</span>
                  </div>
              <div class="mr-3"  v-if="appliedFilter.date.endDate">
                  <span>تا</span>
                  <span class="font-weight-bold mx-1">تاریخ</span
                  ><span> {{ appliedFilter.date.endDate | persianDate }} </span>
              </div>
          </div>
          <div
            class="d-flex mb-3 mr-2-print"
            v-if="adminSelected && adminSelected.id"
          >
            <br>
              <span>صندوق دار:</span>
              <span class="mr-1">{{ adminSelected.name }}</span>
          </div>
          <b-table  
            :total-rows="totalRows"  
            :per-page="perPage"  
            :current-page="currentPage"  
            id="main-table"  
            v-if="reports"  
            bordered  
            striped  
            :fields="unsetField ? fields : fields.slice(0,fields.length - 2)"  
            :items="reports"  
            :filter="filter.search"  
            :sort-by.sync="sortBy"  
            :sort-desc.sync="sortDesc"  
            :filter-included-fields="['title', 'id']"  
            responsive="sm"  
          >  
            <template v-slot:cell(index)="data">  
              {{ data.index + 1 + (currentPage - 1) * perPage }}  
            </template>  
            <template v-slot:cell(id)="data">  
              <a  
              :href="`/admin/shop/orders/${data.item.id}`"  
              class="btn btn-primary"  
              target="_blank"  
              rel="noopener noreferrer"  
            >{{ data.item.id }}</a>  
            </template>  
            <template v-slot:cell(created_at)="data">  
              <span>{{ data.item.created_at | persianDate }}</span>  
            </template>  
            <template v-slot:cell(description)="data">  
              <span v-if="data.item.description !== 'null'">{{ data.item.description }}</span>  
              <span v-else>-</span>  
            </template>  
            <template v-slot:cell(amount)="data">  
              <span>{{ data.item.amount * 10 | price  }}-</span>  
            </template>  
            <template v-slot:cell(return_refund)="data">  
              <span :class="['badge', data.item.return_refund == '1' ? 'badge-success' : 'badge-danger']">  
                {{ data.item.return_refund == '1' ? 'پیگیری شد' : 'پیگیری نشده' }}  
              </span>  
            </template>  
            <template v-slot:cell(edit)="data" >  
              <button  
                class="btn btn-sm btn-icon btn-warning text-white"  
                @click="openModal(data.item.id)"  
                type="button"  
                data-original-title="ویرایش">  
                <i class="fa fa-pencil"></i>  
              </button>  
            </template>  
            <template #bottom-row="data">  
              <b-td>*</b-td>  
              <b-td>*</b-td>  
              <b-td>*</b-td>  
              <b-td>*</b-td>  
              <b-td>جمع کل:</b-td>  
              <b-td>{{ totals.amount * 10 | price  }}-</b-td>  
              <b-td>*</b-td>  
              <b-td>*</b-td>  
            </template>  
          </b-table>  
            <div v-if="reports && !reports.length" class="alert alert-primary">  
                اطلاعاتی موجود نیست  
            </div>  
        </div>
        <div class="d-flex flex-column w-100"></div>
      </div>
      <div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">  
        <div class="modal-dialog modal-md" role="document">  
          <div class="modal-content modal-content-demo">  
            <div class="modal-header">  
              <p class="modal-title font-weight-bold">ویرایش وضعیت مرجوعی</p>  
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">  
                <span aria-hidden="true">×</span>  
              </button>  
            </div>  
            <div class="modal-body">  
              <form @submit.prevent="submitEdit">  
                <div class="form-group">  
                  <label for="status">وضعیت:</label>  
                  <select class="form-control" id="status" v-model="editStatus">  
                    <option value="0">پیگیری نشده</option>  
                    <option value="1">پیگیری شد</option>  
                  </select>  
                </div>  
                <div class="form-group">  
                  <label for="description">توضیحات:</label>  
                  <textarea v-model="editDescription" class="form-control" id="description">{{ editDescription }}</textarea>  
                </div>  
                <input type="hidden" v-model="currentEditId" />  
                <div class="modal-footer justify-content-center">  
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">بستن</button>  
                  <button type="submit" class="btn btn-primary">ذخیره</button>  
                </div>  
              </form>  
            </div>  
          </div>  
        </div>  
      </div>  
    </main>
  </template>
  
  <script>
  import { BTable, BFormGroup, BFormInput, BTd, BPagination } from "bootstrap-vue";
  import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
  import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";
  
  function Filter() {
    this.search = "";
    this.date = {
      startDate: "",
      endDate: "",
    };
  }
  
  Filter.prototype.set = function(filters) {
    Object.entries(filters).forEach(([index, value]) => {
      this[index] = value;
    });
  };
  
  export default {
    name: "StoreErrorsNew",
    components: {
        ExcelDownload,
        DatePickerRange,
        BTable,
        BFormGroup,
        BTd,
        BFormInput,
        BPagination,
    },
    data() {
        return {
            disabled: false,
            fields: [
                {
                    key: "index",
                    label: "ردیف",
                },,
                {
                    key: "customer_mobile",
                    label: "مشتری",
                },
                {
                    key: "id",
                    label: "شناسه فاکتور",
                },
                {
                    key: "description",
                    label: "توضیحات",
                },
                {
                    key: "created_at",
                    label: "تاریخ",
                },
                {
                    key: "amount",
                    label: "مبلغ(ریال)",
                },
                {
                    key: "return_refund",
                    label: "وضعیت",
                },
                {
                    key: "edit",
                    label: "ویرایش",
                },
            ],
            page: 1,
            perPage: 200,
            unsetField: true,
            reports: null,
            sortBy: null,
            totals: null,
            cashiers: null,
            currentEditId: null,
            sortDesc: null,
            adminSelected: null,
            filter: new Filter(),
            editStatus: '',
            editDescription: '',
            appliedFilter: new Filter(),
            currentPage: 1,
        };
    },
    created() {
        this.loadData();
    },
    computed: {
      extraQuery() {
          return {
              from_date: this.filter.date.startDate,
              to_date: this.filter.date.endDate,
          };
      },
      totalRows() {
          return this.reports ? this.reports.length : 0;
      },
    },
    methods: {
        print() {
          window.print();  
        },
        doFilter() {
            this.loadData();
        },
        async loadData() {
          try {
              this.disabled = true;
              this.appliedFilter.set(this.filter);
              const today = new Date();  
              const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);  

              function formatDate(date) {  
                  const year = date.getFullYear();  
                  const month = String(date.getMonth() + 1).padStart(2, '0');  
                  const day = String(date.getDate()).padStart(2, '0');  
                  const hours = String(date.getHours()).padStart(2, '0');  
                  const minutes = String(date.getMinutes()).padStart(2, '0');  
                  const seconds = String(date.getSeconds()).padStart(2, '0');  

                  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;  
              }  
              if (!this.appliedFilter.date.startDate || !this.appliedFilter.date.endDate) {  
                  this.appliedFilter.date.startDate = formatDate(startOfToday);  
                  this.appliedFilter.date.endDate = formatDate(today);  
              }  
              const response = await this.$axios.get("admin/reports/refund-report-new", {  
                  params: {  
                      admin_id: this.adminSelected && this.adminSelected.id ? this.adminSelected.id : "",  
                      from_date: this.appliedFilter.date.startDate,  
                      to_date: this.appliedFilter.date.endDate,  
                  },  
              });  
              this.cashiers = response.data.data.cashiers;  
              this.totals = response.data.data.totals;  
              console.log(this.totals.amount);
              this.reports = Object.values(response.data.data.reports);
          } catch (e) {
          this.$root.notify(e);
          } finally {
          this.disabled = false;
          }
        },
        openModal(id) {  
            this.currentEditId = id;  
            this.editStatus = this.reports.find(report => report.id === id).return_refund;
            this.editDescription = this.reports.find(report => report.id === id).description;
            $('#editModal').modal('show');
        },  
        async submitEdit() {  
          $('#editModal').modal('hide');   
          const data = {  
            return_refund: this.editStatus,
            description: this.editDescription,
          };  
          try {  
            const response = await this.$axios.put(`admin/mini-orders/${this.currentEditId}/update`, data); 
            const currentStatus = response.data.data.miniOrder.return_refund;
            const currentDescription = response.data.data.miniOrder.description;
            this.reports.find(report => report.id === response.data.data.miniOrder.id).return_refund = currentStatus;
            this.reports.find(report => report.id === response.data.data.miniOrder.id).description = currentDescription;
            this.$root.notify(response.data.message, "success");  
          } catch (e) {  
            this.$root.notify(e.message || "خطا در ذخیره‌سازی");
          }  
        }  
      },
    };
</script>
<style >
.print-only {
  display: none;
}
@media print {
  .not-in-print {
    display: none !important;
  }
  #page-refund table tbody tr td:last-child{
    display: none;
  }
  #page-refund table thead tr th:last-child{
    display: none;
  }
  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: flex;
    justify-content: center; 
  }

  body * {
    text-align: center !important;
    background-color: transparent;
    visibility: hidden;
  }
  #print-box,
  #print-box * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print-box {
    padding: 0 !important;
  }
  #print-box {
    width: 100%;
  }

  #print-box .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>